import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=730885d4&"
import script from "./InfoPopup.vue?vue&type=script&lang=ts&"
export * from "./InfoPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports